import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { map, takeLast } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
  standalone: false,
  name: 'secure',
})
export class SecurePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  transform(url, type = ''): Observable<SafeUrl> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      takeLast(1),
      map((val: any) => (type === 'pdf'
        ? URL.createObjectURL(val)
        : this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val)))),
    );
  }
}
